<template>
  <div id="the-upload" ref="input-wrapper">
    <div class="file-input-part" @click="fileClick">
      <label v-if="label"> {{ label }} </label>
      <input
        ref="input"
        :disabled="true"
        v-model="inputText"
        :placeholder="placeholder"
        v-on:input="updateValue($event)"
      />
      <button ref="button">{{ buttonText }}</button>
    </div>
    <div class="hidden-file-input-part">
      <input
        ref="file"
        type="file"
        accept="image/*"
        @change="uploadImage"
        id="file-input"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Upload",
  props: {
    placeholder: {
      type: String,
      required: false,
      default: "Kiválaszt"
    },
    label: {
      type: String,
      required: false
    },
    buttonText: {
      type: String,
      required: false,
      default: "Kép kiválasztás"
    },
    fontSize: {
      type: String,
      required: false,
      default: "13px"
    },
    width: {
      type: String,
      required: false,
      default: "200px"
    },
    height: {
      type: String,
      required: false,
      default: "40px"
    },
    value: {
      required: false
    }
  },
  data() {
    return {
      fileInfo: undefined
    };
  },
  mounted() {
    this.$refs["input-wrapper"].style.width = this.width;
    this.$refs["input"].style.height = this.height;
    this.$refs["input"].style["font-size"] = this.fontSize;
    this.$refs["input"].style["padding-right"] =
      this.$refs["button"].clientWidth + 8 + "px";
    this.$refs["button"].style.height = this.height;
  },
  methods: {
    uploadImage(event) {
      this.fileInfo = event.target.files[0];
      this.$emit("input", event.target.files[0]);
    },
    fileClick() {
      this.$refs.file.click();
    }
  },
  computed: {
    inputText() {
      return this.fileInfo
        ? this.fileInfo.name
        : this.value
        ? this.value
        : this.placeholder;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#the-upload {
  .file-input-part {
    position: relative;
    label {
      margin-bottom: 0;
      margin-left: 5px;
      font-size: 13px;
    }
    input {
      height: 100%;
      width: 100%;
      border-radius: 6px;
      background: #fff;
      padding: 0 0 0 8px;
      outline: none;
      transition: border 1s;
      border: solid 1px #adadad;
      cursor: pointer;
      &:focus {
        transition: box-shadow 1s;
        box-shadow: $input-shadow;
        border: 1px solid $color-primary;
      }
    }
    button {
      height: 30px;
      outline: none;
      position: absolute;
      right: 0;
      bottom: 0;
      border: solid 1px #adadad;
      background: #fff;
      border-radius: 5px;
      padding: 0 10px;
      font-size: 12px;
      font-weight: 500;
      &:hover {
        box-shadow: $input-shadow;
      }
    }
  }
  .hidden-file-input-part {
    display: none;
    input {
      display: none;
    }
  }
}
</style>
